// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2EW_{margin-left:1rem;align-self:center}@media (max-width:61.9375em){._2EW_{position:absolute;right:4rem}}._1j_t{min-height:2rem}.CCyP{margin-bottom:.5rem}@media (max-width:61.9375em){.CCyP>div>div{flex:1;display:flex}}html[dir=rtl] ._2EW_{margin-left:0;margin-right:1rem}@media (max-width:61.9375em){html[dir=rtl] ._2EW_{right:auto;left:4rem}}", ""]);
// Exports
exports.locals = {
	"indicator": "_2EW_",
	"messages": "_1j_t",
	"select": "CCyP"
};
module.exports = exports;
